module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABHNCSVQICAgIfAhkiAAAAPNJREFUKFOlk4ERwUAQRd9WQAk6oANK0AE60IGUEB0oITqgAnSQEnRw5uc25xDCuJnMZHL7d///+2P8cewZG2AGLIA5MATO/mwtvqfzAA6wAyZAYVC1VSE2KoCTwar9nsAOxGD5TonXXA3WqmnATrW0OPXtCVHGAVhKQgsW3Sqn2uHFyLWLmYB1CxYVdf14QpRUArN8cjCX4DJkzuZDp6PFBo3mXybLLAGFacDfatb6RF3ApFnB6HXbBykod7ez6dKeQtDhuBg+7jlLki7HnrC9N9UWpp4wGdUEJIUkn+CBkS5FcgBcfL+KbJ3XvvwYfbvO729PpEgQtpEQIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/automode/退出自动模式.png
// module id = 296
// module chunks = 7